import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './Components/Header';
import HeroSection from './Components/HeroSection';
import Services from './Components/Services';
import AboutUs from './Components/AboutUs';
import Team from './Components/Team';
import Footer from './Components/Footer';
import Testimonials from './Components/Testimonials';
import WhyChoose from './Components/WhyChoose';

import AdminPanel from './AdminPanel';
import AdminLogin from './AdminLogin';
import ProtectedRoute from './ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Home Page */}
        <Route path="/" element={
          <>
            <Header />
            <HeroSection />
            <Services />
            <AboutUs />
            <WhyChoose />
            <Team />
            <Testimonials />
            <Footer />
          </>
        } />

        {/* Admin Login Page */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* Protected Admin Panel */}
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
